<template>
  <span class="username">{{username}}</span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'fin-current-user-name',
  computed: mapGetters('auth', ['username'])
}
</script>

<style scoped>

</style>
